// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__UFmD0","nav-mobile":"Navigation_nav-mobile__4tG8G"};